import { render, staticRenderFns } from "./BankAccountProviderChart.vue?vue&type=template&id=e35d91d8&"
import script from "./BankAccountProviderChart.vue?vue&type=script&lang=js&"
export * from "./BankAccountProviderChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports